import EventBus from '@/EventBus';
import ImageFilterTypes from '@/mixins/ImageFilterTypes';
import { getPropertyApplyTargets } from '@/components/Canvas/utils/groupHelpers';

export default {
  data() {
    return {
      adjustmentInitialPos: {
        leftscalepop: 0,
        topscalepop:  0,
      },
      isScaleOPen: false,
      isBtnActive: false,
      popModal:    {
        isModalOpen: false,
        position:    {
          x: 0,
          y: 0,
        },
      },
      isAdjustmentButtonActive: false,
    };
  },
  computed: {
    adjustEffectRows() {
      const effects = this.activeObjectForLeftPanel && this.activeObjectForLeftPanel.effects;
      if (!effects) {
        return [];
      }
      return [
        ['Brightness', 'brightness'],
        ['Contrast', 'contrast'],
        ['Saturation', 'saturation'],
        ['Tint', 'tint'],
        ['Blur', 'blur'],
        ['Vignette', 'vignette'],
      ].map(([label, name]) => ({
        label,
        name,
        value: effects[name] ? effects[name].value : 0,
      }));
    },
    tintSwatchColor() {
      const color = this.activeObjectForLeftPanel
          && this.activeObjectForLeftPanel.effects
          && this.activeObjectForLeftPanel.effects.tint
          && this.activeObjectForLeftPanel.effects.tint.color;
      return typeof color === 'string' && /^#[0-9a-fA-F]{6}$/.test(color) ? color : '#000000';
    },
    getPopUpModalPositions() {
      return {
        left: `${this.popModal.position.x}px`,
        top:  `${this.popModal.position.y}px`,
      };
    },
    getAdjustmentModalPosition() {
      return { top: `${this.adjustmentInitialPos.topscalepop}px !important` };
    },
    getInitialPositions() {
      return {
        left: `${this.adjustmentInitialPos.leftscalepop + 50}px`,
        top:  `${this.adjustmentInitialPos.topscalepop}px`,
      };
    },
    isSVG() {
      console.log('active object is ', this.activeObjectForLeftPanel);
      if (this.activeObjectForLeftPanel.type == 'image') {
        try {
          const path = this.activeObjectForLeftPanel.DefaultImageUrl;
          if (path && path.split(/[#?]/)[0].split('.').pop().trim() == 'svg') {
            return true;
          }
        } catch (ex) {
          console.log('issue in getting object type', ex.message);
        }
      }
      return false;
    },
  },
  methods: {
    // LeftSection forwards the EventBus 'closeLeftPanelPopovers' event and its own root clicks here.
    closeLeftPanelPopovers() {
      this.isScaleOPen              = false;
      this.isAdjustmentButtonActive = false;
      this.popModal.isModalOpen     = false;
    },
    // LeftSection forwards its root click here: close the popovers when the click is outside them and their buttons.
    closeModalsDefault(e) {
      try {
        const isInsideRef = (ref) => {
          if (!ref) {
            return false;
          }
          if (Array.isArray(ref)) {
            return ref.some(node => node && node.contains(e.target));
          }
          return ref.contains(e.target);
        };
        if (this.$refs.transparencyButton && (!(this.$refs.transparencyButton.contains(e.target)
            || isInsideRef(this.$refs.adjustModalBtn)
            || isInsideRef(this.$refs.adjustModal)
            || isInsideRef(this.$refs.transparencyModal)
            || isInsideRef(this.$refs.cornerRoundingBtn)
            || isInsideRef(this.$refs.cornerRoundingModal)))) {
          this.popModal.isModalOpen = false;
          if (this.cornerRoundingModal) {
            this.cornerRoundingModal.isOpen = false;
          }
          this.isScaleOPen = false;
        }
      } catch (ex) {
        console.log('Error in closing Modal', ex);
      }
    },
    mediaPopTrack(value) {
      const percent = Math.min(100, Math.max(0, Number(value) || 0));
      return {
        background: `linear-gradient(to right, #1570EF ${percent}%, #D5D9E0 ${percent}%, #D5D9E0 100%)`,
      };
    },
    commitMediaSlider(label) {
      setTimeout(() => {
        EventBus.$emit('addIntoPageWiseUndoRedoArray', `Object Image ${label}changed`);
      });
    },
    onAdjustInput(name, raw) {
      const params = { name, value: parseInt(raw, 10) };
      if (name === 'tint' && this.activeObjectForLeftPanel && this.activeObjectForLeftPanel.effects && this.activeObjectForLeftPanel.effects.tint) {
        params.color = this.activeObjectForLeftPanel.effects.tint.color;
      }
      this.changeImageEffects(params);
    },
    onTintColor(event) {
      const tint = this.activeObjectForLeftPanel && this.activeObjectForLeftPanel.effects && this.activeObjectForLeftPanel.effects.tint;
      this.changeImageEffects({
        name:  'tint',
        value: tint ? tint.value : 0,
        color: event.target.value,
      });
      this.commitMediaSlider('tint');
    },
    changeImageEffects(params) {
      const effectValue = (params.name == ImageFilterTypes.TINT) ? {
        value: params.value,
        color: params.color,
      } : {
        value: params.value,
      };
      const targets     = getPropertyApplyTargets(
        this.contentList,
        this.selectedObjectsList,
        this.activeObject,
      );
      targets.forEach((activeObject) => {
        if (!activeObject || !activeObject.effects) {
          return;
        }
        this.$set(activeObject.effects, params.name, effectValue);
      });
    },
    toggleScalePop() {
      if (this.popModal.isModalOpen === true) {
        this.popModal.isModalOpen = false;
      }
      const modalNode       = this.$refs.adjustModal.getBoundingClientRect();
      const modalDimensions = this.$refs.adjustModalBtn.getBoundingClientRect();
      const modalPosition   = modalDimensions.y;
      const modalHeight     = modalNode.height;
      const viewPortHeight  = window.innerHeight;
      if (viewPortHeight < (modalPosition + modalHeight)) {
        const diff                            = viewPortHeight - modalHeight;
        this.adjustmentInitialPos.topscalepop = diff;
      } else {
        this.adjustmentInitialPos.topscalepop = modalDimensions.y;
      }
      this.adjustmentInitialPos.leftscalepop = modalDimensions.x;
      this.isAdjustmentButtonActive          = !this.isAdjustmentButtonActive;
      this.isScaleOPen                       = !this.isScaleOPen;
    },
    openTransparencyModal(e) {
      if (this.cornerRoundingModal) {
        this.cornerRoundingModal.isOpen = false;
      }
      if (this.isScaleOPen === true) {
        this.isScaleOPen = false;
      }
      this.popModal.isModalOpen = !this.popModal.isModalOpen;
      const selectedButton      = this.$refs.transparencyButton.getBoundingClientRect();
      const xPosition           = selectedButton.x + 43;
      const yPosition           = selectedButton.y - 3;
      this.isBtnActive          = !this.isBtnActive;
      const position            = {
        x: xPosition,
        y: yPosition,
      };
      this.popModal.position    = position;
    },
  },
};
